import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Send, Loader2 } from "lucide-react";
import { createBooking } from "../lib/api";
import { useToast } from "../hooks/use-toast";

const BookingDialog = ({ open, onOpenChange, item }) => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: "Champs requis", description: "Merci d'indiquer votre nom et votre e-mail." });
      return;
    }
    setLoading(true);
    try {
      await createBooking({
        kind: item.kind,
        itemId: item.itemId,
        itemName: item.itemName,
        price: item.price || "",
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
      });
      toast({
        title: "Demande envoyée !",
        description: `Votre réservation pour "${item.itemName}" a bien été enregistrée. Je vous recontacte rapidement.`,
      });
      setForm({ name: "", email: "", phone: "", message: "" });
      onOpenChange(false);
    } catch (err) {
      toast({
        title: "Une erreur est survenue",
        description: "Impossible d'envoyer votre demande. Réessayez ou contactez-moi directement.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!item) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0e0e11] border-white/10 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-white">
            Réserver — {item.itemName}
          </DialogTitle>
          <DialogDescription className="text-white/55">
            {item.price ? `Prestation : ${item.price}. ` : ""}Laissez vos coordonnées, je vous
            recontacte au plus vite.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-2">
          <div>
            <label className="block text-sm text-white/70 mb-1.5 font-medium">Nom complet *</label>
            <Input name="name" value={form.name} onChange={handleChange} placeholder="Votre nom" className="bg-white/5 border-white/10 text-white placeholder:text-white/30 h-11" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-white/70 mb-1.5 font-medium">E-mail *</label>
              <Input name="email" type="email" value={form.email} onChange={handleChange} placeholder="vous@email.com" className="bg-white/5 border-white/10 text-white placeholder:text-white/30 h-11" />
            </div>
            <div>
              <label className="block text-sm text-white/70 mb-1.5 font-medium">Téléphone</label>
              <Input name="phone" value={form.phone} onChange={handleChange} placeholder="06 ..." className="bg-white/5 border-white/10 text-white placeholder:text-white/30 h-11" />
            </div>
          </div>
          <div>
            <label className="block text-sm text-white/70 mb-1.5 font-medium">Message</label>
            <Textarea name="message" value={form.message} onChange={handleChange} placeholder="Votre projet, vos questions..." rows={3} className="bg-white/5 border-white/10 text-white placeholder:text-white/30 resize-none" />
          </div>
          <button type="submit" disabled={loading} className="btn-racing w-full justify-center disabled:opacity-70">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
            {loading ? "Envoi..." : "Envoyer ma demande"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default BookingDialog;
